'use strict';

customerZone.run(['$rootScope', '$log', 'Session', 'Storage', 'InvoiceService', 'utils',
    function($rootScope, $log, Session, Storage, service, utils){

        var BREACH_DISMISSAL_KEY = 'breach_notice_dismissed';

        $rootScope.$on(Session.PROFILE_CHANGED_EVENT, utils.debounce(function() {
            if (Session.authenticated() && Session.passwordLeaked()) {
                if (Storage.getItem(BREACH_DISMISSAL_KEY)) return;
                utils.showWarn('your_password_is_on_breach_list', 'password-leak-check', function () {
                    Storage.setItem(BREACH_DISMISSAL_KEY, 'dismissed');
                });
            }
            else {
                Storage.removeItem(BREACH_DISMISSAL_KEY);
            }
        }), 1000);
    }]);

